import type { ComponentProps } from 'react'
import { BookOpen } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { ApiDocsPage } from './admin/ApiDocsPage.js'

/** What the system module contributes to the shells: the API reference, for any admin. */
export const systemWebModule: WebModule<ComponentProps<typeof ApiDocsPage>['api']> = {
  name: 'system',
  adminPages: [{ path: '/admin/docs', label: 'API Docs', title: 'API Reference', icon: BookOpen, group: 'system', page: ({ api }) => <ApiDocsPage api={api} /> }],
}
